<template>
<div v-if="!view || ( atendimento && atendimento.pagamento_atendimento && atendimento.pagamento_atendimento.item_pagamento_atendimentos && atendimento.pagamento_atendimento.item_pagamento_atendimentos.length )">

  <div v-if="!atendimento && !marcacao" class="mt-3">
    <az-empty-state />
  </div>

  <div v-else-if="atendimento">
    <pagamento-pendente :value="dados" />

    <lembrete-pagamento ref="lembrete_pag" v-model="atendimento" @refresh="load()" />

    <div v-if="pode_pagar !== false">

      <div v-if="atendimento.pagamento_atendimento
        && marcacao
        && atendimento.pagamento_atendimento.id_pagamento_atendimento
        && !atendimento.pagamento_atendimento.id_atendimento">

        <a href="#" @click.prevent="$util.abrirPagamentos(marcacao, atendimento.pagamento_atendimento.id_pagamento_atendimento)" class="btn btn-outline-primary mt-2">
          Pagamento Consolidado
        </a>

        <div class="mt-3">Recibo: #{{ atendimento.pagamento_atendimento.id_pagamento_atendimento }}</div>
      </div>

      <template v-else>

        <div v-if="atendimento.pendente" class="alert alert-primary mt-3 d-flex justify-content-between">
          <div>
            <span v-if="atendimento.pendente.id_atendimento">
              {{ atendimento.pendente.num_atend }}
            </span>
            <span v-else-if="atendimento.pendente.dc_valor_adiantado > 0">
              Adiantamento #{{ atendimento.pendente.id_pagamento_atendimento }}
            </span>
          </div>
          <div>
            Pendente
          </div>
        </div>

        <slot></slot>

        <div class="row mt-3">
          <div class="col-12 col-md-6">
            <div class="card alert-secondary">
              <div class="card-body d-flex justify-content-between">
                <div class="lead">Valor Total</div>
                <div class="text-right display-4">{{ format(atendimento.valor_total) }}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="card" :class="cor_saldo()">
              <div class="card-body d-flex justify-content-between">
                <div class="lead">
                  {{ cor_saldo() == 'alert-primary' ? 'Troco' : 'Valor a Pagar' }}
                  <span v-if="validate && cor_saldo() != 'alert-success'" class="text-danger invalid">
                    <i class="fas fa-exclamation"></i>
                  </span>
                </div>
                <div class="text-right display-4">{{ format(saldo_a_pagar ()) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Zoop Status -->
        <zoop-status
            v-if="atendimento && atendimento.pagamento_atendimento && atendimento.pagamento_atendimento.id_pagamento_atendimento > 0"
            :id_pagamento_atendimento="atendimento.pagamento_atendimento.id_pagamento_atendimento"
            :pagamento_atendimento="atendimento.pagamento_atendimento"
            :view_only="true"
            class="mb-3"
        /> 

        <!-- Adiantamento Disponível -->
        <div v-if="adiantamentos && adiantamentos.length" class="alert alert-info">
          Saldo de Adiantamento Disponível: R$ {{ $util.formatMoeda(saldo_adiantamentos) }} 
        </div>

        <!-- Online -->
        <div class="card" v-if="atendimento && atendimento.marcacao.pagamento_online && atendimento.marcacao.pagamento_online.ch_status == 'P'">
          <div class="card-body">
            <pag-online-view :pagamento="atendimento.marcacao.pagamento_online" />
          </div>
        </div>

        <!-- Pagamentos -->

        <div class="row">
          <div class="col">
            <az-sub-title title="Pagamentos">
              <div v-if="atendimento && atendimento.pagamento_atendimento && atendimento.pagamento_atendimento.st_id_externo" class="small text-muted">
                Pag.: {{ atendimento.pagamento_atendimento.st_id_externo }}
              </div>
            </az-sub-title>
          </div>
        </div>

        <div v-if="atendimento && atendimento.pagamento_atendimento">

          <!-- Data -->
          <div class="form-row mb-2" v-if="pode_alterar_data && atendimento && atendimento.pagamento_atendimento">
            <div class="col col-12 col-md-3">
              <az-input
                sizing="sm"
                type="date"
                required
                :validate="validate"
                :edicao="!atendimento.pagamento_atendimento.dt_data
                  || !atendimento.pagamento_atendimento.id_pagamento_atendimento
                  || !atendimento.pagamento_atendimento.item_pagamento_atendimentos.filter(item => {
                      return !item.estorno || item.estorno.ch_situacao != 'A' ;
                  }).length"
                v-model="atendimento.pagamento_atendimento.dt_data" />
            </div>

            <div class="col col-12 col-md-9" v-if="is_adiantamento && atendimento.pagamento_atendimento.medico">
              <az-input
                icon="fas fa-briefcase-medical fa-fw"
                sizing="sm"
                :edicao="false"
                v-model="atendimento.pagamento_atendimento.medico.search" />
            </div>
          </div>

          <div class="form-row mb-2" v-else-if="atendimento && atendimento.pagamento_atendimento && atendimento.pagamento_atendimento.medico">
            <div class="col col-12">
              <az-input
                icon="fas fa-briefcase-medical fa-fw"
                sizing="sm"
                :edicao="false"
                v-model="atendimento.pagamento_atendimento.medico.search">
                <template v-slot:buttonposb>
                    <div class="input-group-append" v-if="atendimento.pagamento_atendimento.medico && !atendimento.pagamento_atendimento.id_pagamento_atendimento && atendimento.id_orcamento">
                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="atendimento.pagamento_atendimento.medico = null">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </template>
              </az-input>
            </div>
          </div>

          <div class="form-row mb-2" v-else-if="is_adiantamento && atendimento && atendimento.pagamento_atendimento && !atendimento.pagamento_atendimento.id_pagamento_atendimento">
            <div class="col col-12">
                <az-input
                    sizing="sm"
                    icon="fas fa-briefcase-medical fa-fw"
                    type="autocomplete"
                    placeholder="Profissional (Opcional)..."
                    optionsMode="aql"
                    service="medicos.index"
                    optionsDisplay="st_nome_exibicao"
                    v-model="atendimento.pagamento_atendimento.medico" />
            </div>
          </div>

          <div v-for="(item, index) in atendimento.pagamento_atendimento.item_pagamento_atendimentos" :key="index">
            <template v-if="!view || !( item.estorno && item.estorno.ch_situacao == 'A' )">
              <div class="form-row">
                <div class="col-12" :class="is_pix(item) ? 'col-md-4' : 'col-md-8'">
                  <az-input
                    sizing="sm"
                    placeholder="none"
                    :icon="item_status (item).icon"
                    :buttonIcon="true"
                    :buttonText="item_status (item).text"
                    :buttonToolTip="item_status (item).tooltip"
                    :buttonColor="item_status (item).color"
                    @clickButton="excluirItem(item, index)"
                    v-model="item.forma_pagamento.search"
                    :edicao="false"
                    v-if="( item.id_item_pagamento_atendimento > 0 && item.forma_pagamento )">
                    <template v-slot:buttonposb v-if="item.id_item_pagamento_atendimento && !view">
                      <div class="input-group-append">
                        <span class="input-group-text" v-if="item.unid_nf" :title="item.unid_nf.st_nome">
                            {{ item.unid_nf.st_sigla ? item.unid_nf.st_sigla : item.unid_nf.st_nome }}
                        </span>
                        <span class="input-group-text" v-if="item.js_outros && item.js_outros.zoop" :title="'ZOOP TID: ' + item.js_outros.zoop.transaction_id + ' / Status: ' + item.js_outros.zoop.status">
                            <i class="fa-solid fa-z mr-2"></i>
                            {{ item.js_outros.zoop.transaction_id }}
                        </span>
                        <az-audit-log-button model="estorno" sizing="sm" :id="item.estorno.id_estorno" v-if="item.estorno" />
                        <az-audit-log-button model="itemPagamentoAtendimento" sizing="sm" :id="item.id_item_pagamento_atendimento" v-else />
                      </div>
                    </template>
                  </az-input>

                  <az-input
                    v-else
                    sizing="sm"
                    placeholder="none"
                    type="select"
                    optionsMode="aql"
                    service="forma_pagamentos.index"
                    optionsData="id_forma_pagamento"
                    optionsDisplay="search"
                    :optionsName="forma_pag_option_name"
                    :optionsParm="( is_pendente_orcamento || is_adiantamento ) ? { adiantamento: true } : {}"
                    @change.native="1 == 0"
                    :icon="item_status (item).icon"
                    :buttonIcon="true"
                    :buttonText="item_status (item).text"
                    :buttonToolTip="item_status (item).tooltip"
                    :buttonColor="item_status (item).color"
                    @clickButton="excluirItem(item, index)"
                    v-model="item.id_forma_pagamento"
                    :validate="validate"
                    :edicao="item.id_item_pagamento_atendimento ? false : true">
                    <template v-slot:buttonposb>
                      <div class="input-group-append">
                        <span class="input-group-text" v-if="item.unid_nf" :title="item.unid_nf.st_nome">
                            {{ item.unid_nf.st_sigla ? item.unid_nf.st_sigla : item.unid_nf.st_nome }}
                        </span>

                        <template v-if="item.id_item_pagamento_atendimento && !view">
                            <az-audit-log-button model="estorno" sizing="sm" :id="item.estorno.id_estorno" v-if="item.estorno" />
                            <az-audit-log-button model="itemPagamentoAtendimento" sizing="sm" :id="item.id_item_pagamento_atendimento" v-else />
                        </template>
                      </div>
                    </template>
                  </az-input>
                </div>

                <template v-if="is_pix(item)">

                  <div class="col-12" :class="( item.forma_pagamento 
                      && item.forma_pagamento.forma_pagamento
                      && item.forma_pagamento.forma_pagamento.bandeira_cartaos 
                      && item.forma_pagamento.forma_pagamento.bandeira_cartaos.length )
                      || item.id_bandeira_cartao ? 'col-md-2' : 'col-md-4'">
                    <az-input
                      sizing="sm"
                      placeholder="Identificação..."
                      type="text"
                      icon="fas fa-stamp fa-fw"
                      v-model="item.st_autorizacao"
                      :validate="validate"
                      :edicao="( item.id_item_pagamento_atendimento && ( item.lancamentos && item.lancamentos[0] && item.lancamentos[0].ch_status != 'P' ) ) ? false : true"
                    />
                  </div>

                  <div class="col-12 col-md-2" v-if="item.forma_pagamento 
                      && item.forma_pagamento.forma_pagamento
                      && item.forma_pagamento.forma_pagamento.bandeira_cartaos 
                      && item.forma_pagamento.forma_pagamento.bandeira_cartaos.length">
                    <az-input
                      sizing="sm"
                      placeholder="Bandeira..."
                      type="select"
                      icon="fa-solid fa-money-check-dollar fa-fw"
                      :optionsList="item.forma_pagamento.forma_pagamento.bandeira_cartaos"
                      optionsData="id_bandeira_cartao"
                      optionsDisplay="search"
                      v-model="item.id_bandeira_cartao"
                      :validate="validate"
                      required
                      :edicao="item.id_item_pagamento_atendimento ? false : true"
                    />
                  </div>

                  <div class="col-12 col-md-2" v-else-if="item.bandeira_cartao">
                    <az-input
                      sizing="sm"
                      placeholder="Bandeira..."
                      icon="fa-solid fa-money-check-dollar fa-fw"
                      v-model="item.bandeira_cartao.search"
                      :edicao="false" />
                  </div>

                </template>

                <!-- Pagamento via App Integrado -->

                <div class="col-12 col-md-4 d-flex flex-column" v-if="atendimento && atendimento.id_atendimento && !item.id_item_pagamento_atendimento && item.id_forma_pagamento == 90">
                  <button class="btn btn-sm btn-success" @click="realizar_pagamento_app(item)" :disabled="$store.state.loading || item.aguardando_app">
                    <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="$store.state.loading"></span>
                    {{ item.aguardando_app ? 'Aguardando Pagamento' : 'Realizar Pagamento Kivid' }}
                  </button>
                </div>

                <div class="col-12" :class="is_pix(item) ? 'col-md-2' : 'col-md-4'" v-else>
                  <az-input
                    sizing="sm"
                    :ref="'valorparticular' + index"
                    v-model="item.dc_valor"
                    :type="item.dc_valor === null ? 'number' : 'money'"
                    required
                    :validate="validate"
                    :edicao="item.id_item_pagamento_atendimento ? false : true">
                    <template v-slot:buttonposb>
                      <div class="input-group-append" v-if="!item.id_item_pagamento_atendimento">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Dividir valor em parcelas"
                          v-if="( item.id_forma_pagamento == 4 || item.id_forma_pagamento == 50 || is_pix(item) ) && item.dc_valor"
                          @click="dividir(item)">
                          <i class="fa-solid fa-divide"></i>
                        </button>

                        <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                          @click="set_valor(item)">
                          <i class="fas fa-equals"></i>
                        </button>

                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Distribuição de valor particular."
                          @click="distribuir_pagamento(item)" v-if="atendimento && atendimento.pagamento_distribuido && atendimento.pagamento_distribuido.length > 1">
                          <i class="fa-solid fa-file-dashed-line"></i>
                        </button>
                      </div>
                    </template>
                  </az-input>
                </div>
                <!-- Fim Valor -->

                <div class="col-12 col-md-2" v-if="is_pix(item) && item.cheque">
                    <az-input
                        sizing="sm"
                        placeholder="Data..."
                        type="date"
                        icon="far fa-calendar-alt fa-fw"
                        v-model="item.cheque.dt_vencimento"
                        :validate="validate"
                        :edicao="item.id_item_pagamento_atendimento ? false : true" />
                </div>
              </div>
            </template>

            <div v-if="item.id_forma_pagamento == 90 && item.aguardando_app" class="alert alert-success mt-3">
              Aguarde realização do pagamento pelo paciente.
            </div>

            <!-- Adiantamento -->
            <div class="form-row mb-2" v-if="!item.id_item_pagamento_atendimento" v-show="item.id_forma_pagamento == 99">
              <div class="col-12">
                <p class="alert alert-warning" v-if="!adiantamentos || !adiantamentos.length">
                  Nenhum adiantamento identificado.
                </p>
                <az-input
                  sizing="sm"
                  type="select"
                  placeholder="Selecione o adiantamento..."
                  optionsMode="json"
                  optionsDisplay="search_adiantamento"
                  :optionsList="adiantamentos"
                  required
                  :validate="validate"
                  v-model="item.adiantamento" />
                <pre v-if="false">{{ adiantamentos }}</pre>
              </div>
            </div>

            <div class="form-row mb-2" v-if="item.id_item_pagamento_atendimento && item.id_forma_pagamento == 99 && item.adiantamento">
              <div class="col-12">
                <label class="form form-control form-control-sm disabled">
                  Adiantamento #{{ item.adiantamento.id_pagamento_atendimento }} -
                  {{ $util.getFormatDate(item.adiantamento.dt_data.substr(0,10)) }} -
                  R$ {{ $util.formatMoeda(item.adiantamento.dc_valor_adiantado) }}
                </label>
              </div>
            </div>

            <!-- Cartão de Crédito -->
            <div class="form-row mb-2" v-show="item.id_forma_pagamento == 2">
              <div class="col-12 col-md-4">
                <az-input
                  sizing="sm"
                  id="credito"
                  placeholder="Selecione a Bandeira..."
                  type="select"
                  optionsMode="aql"
                  service="bandeira_cartaos.index"
                  optionsData="id_bandeira_cartao"
                  optionsDisplay="search"
                  :optionsName="'band_card.index.'
                    + ( marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao ) 
                    + ( marcacao ? '.r.' + marcacao.id_recepcao : '' )"
                  :optionsParm="{
                    where: { ch_tipo: 'C' },
                    id_unidade_operacao: marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao,
                    id_recepcao: marcacao ? marcacao.id_recepcao : '', 
                  }"
                  @change.native="1 == 0"
                  icon="fas fa-credit-card fa-fw"
                  v-model="item.id_bandeira_cartao"
                  :required="item.id_forma_pagamento == 2 && !item.id_item_pagamento_atendimento"
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>
              <div class="col-12 col-md-4">
                <az-input
                  sizing="sm"
                  placeholder="Parcelas..."
                  :type="item.id_item_pagamento_atendimento ? 'number' : 'select'"
                  optionsMode="json"
                  :service="'parcelas.' + item.id_bandeira_cartao"
                  :optionsList="parcelas (item.id_bandeira_cartao, 'band_card.index.'
                     + ( marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao )
                     + ( marcacao ? '.r.' + marcacao.id_recepcao : '' ) )"
                  optionsData="id"
                  optionsDisplay="search"
                  @change.native="1 == 0"
                  icon="fas fa-times fa-fw"
                  v-model="item.in_parcelas"
                  :required="item.id_forma_pagamento == 2 && !item.id_item_pagamento_atendimento"
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>
              <div class="col-12 col-md-4">
                <az-input
                  sizing="sm"
                  placeholder="Autorização/CV/NSU"
                  type="text"
                  icon="fas fa-stamp fa-fw"
                  v-model="item.st_autorizacao"
                  :validate="validate"
                  :edicao="( item.id_item_pagamento_atendimento && ( item.lancamentos && item.lancamentos[0] && item.lancamentos[0].ch_estado != 'P' ) ) ? false : true"
                />
                  </div>
            </div>

            <!-- Cartão de Débito -->
            <div class="form-row mb-2" v-show="item.id_forma_pagamento == 3">
              <div class="col-12 col-md-8">
                <az-input
                  sizing="sm"
                  id="debito"
                  placeholder="Selecione a Bandeira..."
                  type="select"
                  optionsMode="aql"
                  service="bandeira_cartaos.index"
                  optionsData="id_bandeira_cartao"
                  optionsDisplay="search"
                  :optionsName="'band_card_debito.index.'
                    + ( marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao ) 
                    + ( marcacao ? '.r.' + marcacao.id_recepcao : '' )"
                  :optionsParm="{
                    where: { ch_tipo: 'D' },
                    id_unidade_operacao: marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao, 
                    id_recepcao: marcacao ? marcacao.id_recepcao : '',
                  }"
                  @change.native="1 == 0"
                  icon="far fa-credit-card fa-fw"
                  v-model="item.id_bandeira_cartao"
                  :required="item.id_forma_pagamento == 3 && !item.id_item_pagamento_atendimento"
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>
              <div class="col-12 col-md-4">
                <az-input
                  sizing="sm"
                  placeholder="Autorização..."
                  type="text"
                  icon="fas fa-stamp fa-fw"
                  v-model="item.st_autorizacao"
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>
            </div>

            <!-- Cheque -->
            <div class="form-row mb-2" v-if="( item.id_forma_pagamento == 4 || item.id_forma_pagamento == 50 ) && item.cheque">
              <div class="col-12 col-md-3">
                <az-input
                  sizing="sm"
                  placeholder="Banco..."
                  type="select"
                  optionsMode="aql"
                  service="bancos.index"
                  optionsData="id_banco"
                  optionsDisplay="search"
                  @change.native="1 == 0"
                  icon="fas fa-building fa-fw"
                  v-model="item.cheque.id_banco"
                  required
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>

              <div class="col-12 col-md-3">
                <div class="input-group input-group-sm" v-if="item.id_forma_pagamento == 4">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <input
                        type="checkbox"
                        aria-label="Checkbox for following text input"
                        v-model="item.cheque.fl_mesma_praca"
                      />
                    </div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    value="Mesma praça"
                    :disabled="item.id_item_pagamento_atendimento ? true : false"
                  />
                </div>
              </div>

              <div class="col-12 col-md-3">
                <az-input
                  sizing="sm"
                  placeholder="Número..."
                  type="text"
                  @change.native="1 == 0"
                  icon="fas fa-hashtag fa-fw"
                  v-model="item.cheque.in_numero"
                  required
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>

              <div class="col-12 col-md-3">
                <az-input
                  sizing="sm"
                  placeholder="Data..."
                  type="date"
                  icon="far fa-calendar-alt fa-fw"
                  v-model="item.cheque.dt_vencimento"
                  required
                  :validate="validate"
                  :edicao="item.id_item_pagamento_atendimento ? false : true"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" v-if="!view && atendimento.valor_total > 0 && ( !atendimento.pagamento_atendimento || !atendimento.pagamento_atendimento.aguardando_app )">
          <div class="col">
            <az-input
              sizing="sm"
              placeholder="Selecione Forma de Pagamento..."
              type="select"
              optionsMode="aql"
              service="forma_pagamentos.index"
              optionsData="id_forma_pagamento"
              optionsDisplay="search"
              :optionsName="forma_pag_option_name"
              :optionsParm="( is_pendente_orcamento || is_adiantamento ) 
                ? { adiantamento: true, id_unidade_operacao: marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao } 
                : { id_unidade_operacao: marcacao ? marcacao.id_unidade_operacao : id_unidade_operacao }"
              @input="incluirForma ()"
              icon="fas fa-plus fa-fw"
              v-model="novaForma"
            />
          </div>
        </div>

        <!-- Desconto -->

        <template v-if="!is_adiantamento && !atendimento.pendente">

          <div class="form-row">
            <div class="col">
              <az-sub-title title="Desconto" />
            </div>
          </div>

          <div class="form-row" v-if="atendimento.pagamento_atendimento && atendimento.pagamento_atendimento.desconto">
            <div class="col-12 col-md-4" v-if="atendimento && atendimento.tem_alcada">
              <az-input
                type="autocomplete"
                sizing="sm"
                label="Desconto"
                placeholder="Selecione o Desconto..."
                optionsMode="aql"
                :optionsParm="{ ativos: true, id_marcacao: marcacao ? marcacao.id_marcacao : -1 }"
                service="desconto_tipos.index"
                :edicao="!view"
                v-model="atendimento.pagamento_atendimento.desconto.desconto.desconto_tipo" 
                @input="calcular_desconto_lista()" />
              <div v-if="atendimento.pagamento_atendimento.desconto.desconto.autorizador" class="small text-muted mb-2">
                Autorizador por {{ atendimento.pagamento_atendimento.desconto.desconto.autorizador.st_login }}
              </div>
            </div>
            
            <div class="col-12" :class="atendimento.tem_alcada ? 'col-md-4' : 'col-md-8'">
              <az-input
                sizing="sm"
                label="Motivo do Desconto"
                v-model="atendimento.pagamento_atendimento.desconto.desconto.st_desconto"
                :required="atendimento.pagamento_atendimento.desconto.desconto.dc_valor ? true : false"
                :edicao="!view"
                :validate="validate">
                <template v-slot:buttonposb>
                  <div class="input-group-append">

                    <az-audit-log-button 
                      model="desconto" 
                      sizing="sm" 
                      :id="atendimento.pagamento_atendimento.desconto.desconto.id_desconto" 
                      v-if="atendimento.pagamento_atendimento.desconto.desconto.id_desconto" />

                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="abrir_calc_desconto()" v-if="!view">
                      <i class="fa fa-percent" aria-hidden="true"></i>
                    </button>

                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                      v-if="atendimento.pagamento_atendimento.desconto.desconto.dc_valor > 0">
                      {{ 
                        atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto == 'T' 
                          ? 'Geral'
                          : ( atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto == 'A'
                              ? 'Apenas em...'
                              : ( atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto == 'E' ? 'Exceto em...' : '?' )
                          )
                      }}
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#" @click.prevent="atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto = 'T'">Geral</a>
                      <a class="dropdown-item" href="#" @click.prevent="atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto = 'A'">Apenas em...</a>
                      <a class="dropdown-item" href="#" @click.prevent="atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto = 'E'">Exceto em...  </a>
                    </div>

                  </div>
                </template>
              </az-input>
            </div>
            <div class="col-12 col-md-4">
              <!--  && !atendimento.tem_alcada -->
              <az-input
                v-if="!mudando_desconto"
                type="money"
                sizing="sm"
                label="Valor"
                :edicao="!view"
                v-model="atendimento.pagamento_atendimento.desconto.desconto.dc_valor">
                <template v-slot:buttonposb>
                  <div class="input-group-append" v-if="atendimento.pagamento_atendimento.desconto.desconto.dc_valor > 0 && atendimento.valor_total > 0">
                    <span class="input-group-text" id="basic-addon2">
                      {{ $util.formatMoeda( ( atendimento.pagamento_atendimento.desconto.desconto.dc_valor / atendimento.valor_total ) * 100, 2 ) }}%
                    </span>
                  </div>
                </template>
              </az-input>

              <az-input
                v-else
                sizing="sm"
                label="Valor"
                :edicao="false"
                :value="$util.formatMoeda(atendimento.pagamento_atendimento.desconto.desconto.dc_valor)"
              />
            </div>
          </div>

          <!-- Detalhamento do Desconto -->
          <template v-if="atendimento.pagamento_atendimento 
            && atendimento.pagamento_atendimento.desconto 
            && atendimento.pagamento_atendimento.desconto.desconto.dc_valor > 0
            && atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto
            && atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto != 'T'">

            <div v-for="(atp, itx) in atendimento.atendimento_procedimentos" :key="itx">
              <az-input
                sizing="sm"
                type="checkbox-group"
                :label="atp.procedimento.st_procedimento"
                v-model="atp.desc.fl_ativo">
                <template v-slot:buttonposcb>
                  <div class="input-group-append" v-if="atp.desc.fl_ativo">
                    <template v-if="atp.dc_valor_consumo">
                      <div class="input-group-text">
                        <input type="checkbox" v-model="atp.desc.fl_procedimento">
                        <span class="ml-2">Procedimento</span>
                      </div>
                      <div class="input-group-text">
                        <input type="checkbox" v-model="atp.desc.fl_consumo">
                        <span class="ml-2">Mat/Med/Taxas</span>
                      </div>
                    </template>
                    <span class="input-group-text" v-if="atp.desc.fl_procedimento || atp.desc.fl_consumo">
                      {{ $util.formatMoeda(
                        ( atp.desc.fl_procedimento && atp.desc.fl_consumo ) ? atp.cd_valor_total
                          : ( atp.desc.fl_consumo ? atp.dc_valor_consumo
                            : atp.cd_valor_total - atp.dc_valor_consumo ) ) 
                      }}
                    </span>
                  </div>
                </template>
              </az-input>
            </div>

          </template>

        </template>

        <!-- Observação -->
        <div class="form-row">
          <div class="col" :class="( nota_habilitada || atendimento.pendente ) ? 'col-12' : 'col-8'">
              <az-input
                sizing="sm"
                label="Observação"
                v-model="atendimento.pagamento_atendimento.st_observacoes" />
          </div>
          <div class="col col-2" v-if="!nota_habilitada && !atendimento.pendente">
              <az-input
                sizing="sm"
                label="Número da Nota Fiscal"
                v-model="atendimento.pagamento_atendimento.st_numero_nf" />
          </div>
          <div class="col col-2" v-if="!nota_habilitada && !atendimento.pendente">
              <az-input
                sizing="sm"
                label="Chave de Acesso da NF"
                v-model="atendimento.pagamento_atendimento.st_chave_acesso" />
          </div>

          <!-- NF e chave de acesso -->
        </div>

      <!-- Outro Reponsável Financeiro -->
      <div v-show="tem_endereco_antigo"> <!-- && !atendimento.pendente"> -->
          <div class="row" v-if="!view">
            <div class="col col-12 col-md-4 d-flex align-items-start">
              <div class="custom-control custom-switch my-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitchAll"
                  v-model="outro_responsavel"
                  @click="ajustar_selecao"
                  :disabled="possui_nota_fiscal()" />
                <label
                  class="custom-control-label"
                  for="customSwitchAll"
                >Informar outro responsável financeiro</label>
              </div>
            </div>
            <div class="col col-12 col-md-2" v-if="outro_responsavel">
              <az-input
                sizing="sm"
                label="CPF/CNPJ"
                type="cpf-cnpj"
                placeholder="CPF / CNPJ..."
                v-model="atendimento.pagamento_atendimento.st_cpf_cnpj"
                required
                :validate="validate"
                :edicao="!possui_nota_fiscal()"
                @input="pesquisarCpf"
              />
            </div>
            <div class="col col-12 col-md-6" v-if="outro_responsavel">
              <az-input
                sizing="sm"
                label="Nome/Empresa"
                placeholder="Nome / Empresa..."
                v-model="atendimento.pagamento_atendimento.st_responsavel_financeiro"
                required
                :edicao="!possui_nota_fiscal()"
                :validate="validate"
              />
            </div>
          </div>

          <div class="row" v-if="outro_responsavel">
            <div class="col col-12 col-md-6">
              <az-input
                sizing="sm"
                label="e-mail"
                type="email"
                placeholder="e-mail"
                v-model="atendimento.pagamento_atendimento.st_email"
                :edicao="!possui_nota_fiscal()"
                :validate="validate"
              />
            </div>

            <div class="col col-12 col-md-6">
              <az-input
                v-if="atendimento.pagamento_atendimento.st_cpf_cnpj && atendimento.pagamento_atendimento.st_cpf_cnpj.length == 14"
                sizing="sm"
                class="mt-4"
                label="Reter ISS"
                type="checkbox-group"
                v-model="atendimento.pagamento_atendimento.ch_iss_retido"
                :validate="validate"
                :edicao="!possui_nota_fiscal()"
              />
            </div>
          </div>

          <div class="row" v-if="outro_responsavel">
            <div class="col col-12 col-md-12">
              <az-input
                  sizing="sm"
                  label="Endereço"
                  placeholder="Endereço..."
                  v-model="atendimento.pagamento_atendimento.st_endereco"
                  required
                  :edicao="!possui_nota_fiscal()"
                  :validate="validate"
              />
            </div>
          </div>

        </div>

        <div v-show="!tem_endereco_antigo"> <!-- && !atendimento.pendente"> -->
          <div class="row" v-if="!view">
              <div class="col col-12"> <!-- col-md-12 d-flex align-items-start -->
                <div class="custom-control custom-switch my-3" >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitchAll"
                    v-model="outro_responsavel"
                    @click="ajustar_selecao"
                    :disabled="possui_nota_fiscal()" />
                  <label
                    class="custom-control-label"
                    for="customSwitchAll"
                  >Informar outro responsável financeiro</label>
                </div>

                <div v-if="outro_responsavel && responsaveis && responsaveis.lista && responsaveis.lista.length">
                  <div class="card">
                    <div class="card-header px-2 py-1">
                      <a href="#" @click.prevent="responsaveis.expandido = !responsaveis.expandido" class="card-link">
                        Responsáveis em Atendimentos Anteriores
                      </a>
                    </div>
                    <ul class="list-group" v-if="responsaveis.expandido">
                      <li class="list-group-item d-flex justify-content-between" v-for="(resp, irx) in responsaveis.lista" :key="irx">
                        <div>
                          <div>
                            <a href="#" @click.prevent="selecionarResponsavel(resp)" class="card-link">
                              {{ resp.st_responsavel_financeiro }}
                            </a>
                          </div>
                          <div class="small text-muted">{{ resp.st_endereco }}</div>
                        </div>
                        <div>
                          {{ resp.st_cpf_cnpj }}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col col-12 col-md-6">
              <div class="row">
                <div class="col col-6 col-md-6" v-if="outro_responsavel">
                  <az-input
                    sizing="sm"
                    label="CPF/CNPJ"
                    type="cpf-cnpj"
                    placeholder="CPF / CNPJ..."
                    v-model="atendimento.pagamento_atendimento.st_cpf_cnpj"
                    required
                    :validate="validate"
                    :edicao="!possui_nota_fiscal() && !atendimento.pagamento_atendimento.fl_estrangeiro"
                    @input="pesquisarCpf"
                  >
                  <template v-slot:buttonposb>
                      <div class="input-group-append" v-if="true || !atendimento.pagamento_atendimento.st_cpf_cnpj">
                          <div class="input-group-text">
                              <input type="checkbox" aria-label="Checkbox for following text input" v-model="atendimento.pagamento_atendimento.fl_estrangeiro" :disabled="possui_nota_fiscal()">
                          </div>
                          <div class="input-group-text">
                              Sem CPF 
                          </div>
                      </div>
                    </template>
                </az-input>
                </div>
                <div class="col col-6 col-md-6" v-if="outro_responsavel">
                  <az-input
                    sizing="sm"
                    label="Inscrição Municipal"
                    type="inscricao-municipal"
                    placeholder="Inscrição Municipal"
                    v-model="atendimento.pagamento_atendimento.st_inscricao_municipal"
                    :validate="validate"
                    :edicao="!possui_nota_fiscal()"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col col-12 col-md-12" v-if="outro_responsavel">
                  <az-input
                    sizing="sm"
                    label="Nome/Empresa"
                    placeholder="Nome / Empresa..."
                    v-model="atendimento.pagamento_atendimento.st_responsavel_financeiro"
                    required
                    :edicao="!possui_nota_fiscal()"
                    :validate="validate"
                  />
                </div>
              </div>

              <div class="row" v-if="outro_responsavel">
                <div class="col col-12 col-md-12">
                  <az-input
                    sizing="sm"
                    label="e-mail"
                    type="email"
                    placeholder="e-mail"
                    v-model="atendimento.pagamento_atendimento.st_email"
                    :edicao="!possui_nota_fiscal()"
                    :validate="validate"
                  />
                </div>
                <div class="col col-12 col-md-12">
                  <az-input
                    v-if="atendimento.pagamento_atendimento.st_cpf_cnpj && atendimento.pagamento_atendimento.st_cpf_cnpj.length == 14"
                    sizing="sm"
                    class="mt-4"
                    label="Reter ISS"
                    type="checkbox-group"
                    v-model="atendimento.pagamento_atendimento.ch_iss_retido"
                    :validate="validate"
                    :edicao="!possui_nota_fiscal()"
                  />
                </div>
              </div>
            </div>

            <div class="col col-12 col-md-6">
              <div class="row" v-if="outro_responsavel">
                <div class="col col-12 col-md-12">
                  <cadastro-endereco :validate="validate" sizing="sm" :edicao="!possui_nota_fiscal()" v-model="atendimento.pagamento_atendimento.endereco"/>
                </div>
              </div>
            </div>
          </div>

        </div>

        <template v-if="marcacao && atendimento && atendimento.marcacao && atendimento.marcacao.tem_pagamento_multiplo">
            <a href="#" @click.prevent="$util.abrirPagamentos(marcacao)" class="btn btn-outline-primary mb-2" 
                v-if="( !atendimento.pagamento_atendimento || !atendimento.pagamento_atendimento.id_pagamento_atendimento ) && ( dados && dados.outras && dados.outras.length )">
                Pagamento Consolidado
            </a>

            <outras-marcacoes :dados="dados" @reabrir="reabrir" v-if="dados" />
        </template>

        <template v-if="atendimento && atendimento.pagamento_atendimento && atendimento.pagamento_atendimento.campos_customizados">
          <!-- Campos Customizados -->

          <div v-if="atendimento.pagamento_atendimento.campos_customizados.js_campos.length" class="row mt-3">
              <div class="col col-12">
                  <az-sub-title :title="atendimento.pagamento_atendimento.campos_customizados.st_titulo" />
                  <formulario 
                      :gutters="true" 
                      v-model="atendimento.pagamento_atendimento.campos_customizados.js_campos" 
                      :saved="true" 
                      mode="fixed"
                      :validate="validate"
                      :config="true" />
              </div>
          </div>

          <!-- Fim Campos Customizados -->
        </template>

        <template v-if="!view && atendimento && lista_lancamentos(atendimento).length"> <!-- atendimento.adiantamento &&  -->
          <div class="card mt-3 mb-0">
            <div class="card-header d-flex justify-content-between">
              <div>
                <a href="#" @click.prevent="atendimento.fl_reembolso = !atendimento.fl_reembolso" class="card-link">
                  Lançamentos
                </a>
              </div>
              <div>
                <span class="badge badge-secondary">
                  {{ lista_lancamentos(atendimento).length }}
                </span> 
              </div>
            </div>
            <ul class="list-group" v-if="atendimento.fl_reembolso">
              <li class="list-group-item d-flex justify-content-between" v-for="(lanc, ilx) in lista_lancamentos(atendimento)" :key="ilx">
                <div>
                  #{{ lanc.id_lancamento }}
                  <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                  {{ lanc.st_descricao }}
                  <a href="#" @click.prevent="abrir_anexar_arquivo(lanc)" class="ml-2 card-link d-print-none">
                    <i class="fa fa-plus" aria-hidden="true" v-if="!lanc.arquivos.length"></i>
                    <div class="spinner-border spinner-border-sm" role="status" v-else-if="lanc.carregando">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <i class="fa fa-paperclip" aria-hidden="true" v-else></i>
                  </a>

                  <span v-if="lanc.unidade_operacao && lanc.unidade_operacao.st_sigla" class="badge badge-light ml-2">
                    {{ lanc.unidade_operacao.st_sigla }}
                  </span>

                  <div class="small text-muted">
                    Vencimento: {{ $util.getFormatDate(lanc.dt_vencimento) }}
                  </div>
                  <div v-if="lanc.ch_estado == 'C'">
                    <span class="badge badge-danger">
                      Cancelado
                    </span>
                  </div>
                </div>
                <div>{{ $util.formatMoeda(lanc.dc_valor) }}</div>
              </li>
            </ul>
          </div>
          
          <!-- Envio de Arquivo -->
          <template v-if="acao_anexar && lanc_selec">
            <az-file-upload
              ref="upload"
              @refresh="carregar_arquivos()"
              :multiple="true"
              :arquivos="lanc_selec.arquivos"
              :parms="{ model_type: 'lancamento', model_id: lanc_selec.id_lancamento }" />
          </template>
        </template>

        <div v-if="ver_repasse_apuracao && atendimento && !view" class="mt-3">
          <repasse-apuracao 
              ref="apuracao"
              :id_medico="atendimento ? atendimento.id_medico : null" 
              origem="P" 
              :simulacao="true"
              :resumo_pagamento="true"
              :parms="{
                id_atendimento: ( atendimento ? atendimento.id_atendimento : null ), 
                tipo_filtro: 'I',
                exibir_valor_clinica: true, 
                completo: true, 
                campos_exibir: 'R', 
              }" /> 
        </div>

        <div v-if="1 == 0">
          Pagamento...
          <pre>{{ atendimento }}</pre>
        </div>

        <div class="alert alert-secondary p-2 mt-3" v-if="atendimento && atendimento.usuario">
            Usuário Atendimento: {{ atendimento.usuario.st_login }}
        </div>
        
      </template>

    </div>

    <!-- Quando não pode realizar pagamento -->
    <div v-else>

        <template v-if="marcacao.item_status.ultima_etapa.id_etapa_atendimento < 3">
 
            <div class="alert alert-warning d-flex justify-content-between mt-3">
                <div>Atendimento realizado. Encaminhar para pagamento.</div>
                <div>
                    <a href="#" @click.prevent="incluir_lembrete()" class="card-link">
                        <i class="fas fa-thumbtack"></i>
                    </a>
                </div>
            </div>

        </template>

        <div v-else>

            <p class="alert alert-info mt-3">
                Atendimento realizado.
            </p>

            <!-- Espelho do Atendimento -->
            <template v-if="dados && marcacao">
                <div class="d-flex">
                    <div>
                        <print-export printid="print-espelho-atendimento" :icon="false">
                            <template v-slot:botao>
                                <span class="mr-2">Espelho do Atendimento</span>
                            </template>
                        </print-export>
                    </div>
                </div>

                <div id="print-espelho-atendimento" class="d-none d-print-block">
                    <espelho-atendimento :dados="dados" :prazo="dados.exibir_prazo" />
                </div>
            </template>

        </div>

        <laboratorio-etiqueta v-model="dados" />

        <!-- Atendimentos Realizados -->
        <div v-if="atendimento && atendimento.marcacoes">
            <table class="table table-sm table-hover small mt-3">
                <thead>
                    <tr>
                        <th>Atend</th>
                        <th>Data</th>
                        <th>Procedimento</th>
                        <th>Profissional</th>
                        <th class="text-right">Valor Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(marc, iax) in atendimento.marcacoes" :key="iax">
                        <td>#{{ marc.id_atendimento }}</td>
                        <td>{{ $util.getFormatDate(marc.dt_inicio) }} {{ marc.dt_inicio.slice(11,16) }}</td>
                        <td>{{ marc.procedimento.search }}
                            <span class="badge badge-primary" v-if="marc.atendimento.atendimento_procedimentos.length > 1">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                {{ marc.atendimento.atendimento_procedimentos.length - 1 }}
                            </span>
                        </td>
                        <td>{{ marc.medico.search }}</td>
                        <td class="text-right">{{ $util.formatMoeda(marc.atendimento.valor_total) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th colspan="4">Total</th>
                        <th class="text-right">{{ $util.formatMoeda(atendimento.marcacoes.reduce((acc, marc) => acc + marc.atendimento.valor_total, 0)) }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- Outras Marcações -->
        <outras-marcacoes class="mt-3" :dados="dados" @reabrir="reabrir" />

        <!-- Documentos para Impressão -->
        <doc-print-atendimento class="mt-3" :marcacao="dados" v-if="dados && dados.docs && dados.docs.length" />
    </div>

    <!-- Modal -->
    <div class="modal fade" id="estornoMotivoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Solicitar Estorno</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-input
              label="Motivo"
              type="textarea"
              rows="5"
              :validate="validate"
              required
              v-model="motivo_estorno" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="enviar_solicitar_estorno()">Solicitar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Percentual de Desconto -->
    <div class="modal fade" id="pagamentoDescontoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Percentual de Desconto</h5>
            <button type="button" class="close" aria-label="Close" @click="fechar_modal('pagamentoDescontoModal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              type="money"
              v-model="perc_desconto">
              <template v-slot:button-pre>
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">
                    <i class="fa fa-percent fa-fw" aria-hidden="true"></i>
                  </span>
                </div>
              </template>
            </az-input>

            <az-input
              type="checkbox-group"
              label="Apenas sobre o saldo"
              v-model="desconto_no_saldo" />

            <div class="alert alert-info">
              Valor do Desconto: 
              {{ $util.formatMoeda(valor_desconto) }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('pagamentoDescontoModal')">Fechar</button>
            <button type="button" class="btn btn-success" @click="calcular_desconto()">Calcular</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Autorizaçào de Desconto -->
  <div class="modal fade" id="autDescontoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="autdesc">
            <div class="modal-header">
                <h5 class="modal-title">Autorização de Desconto</h5>
                <button type="button" class="close" @click="fechar_modal('autDescontoModal')" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col col-12">
                        <input
                            placeholder="Login..."
                            type="text"
                            v-model="autdesc.login"
                            required
                            :validate="validate"
                            autocomplete="off"
                            class="form form-control" />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col col-12">
                        <input
                            placeholder="Senha..."
                            type="text"
                            id="password"
                            style="-webkit-text-security: disc;"
                            required
                            :validate="validate"
                            v-model="autdesc.senha"
                            autocomplete="off"
                            class="form form-control" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="fechar_modal('autDescontoModal')">Fechar</button>
                <az-submit @click="atualizar(autdesc.callback, autdesc.final)">Confirmar</az-submit>
            </div>
        </div>
    </div>
  </div>

  <!-- Divisão em Parcelas -->
  <div class="modal fade" id="dividirValoresModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Dividir</h5>
          <button type="button" class="close" @click="fechar_modal('dividirValoresModal')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="col col-12">
              <form autocomplete="off" @submit.prevent>
                <small class="form-text text-muted text-nowrap text-truncate">
                  Número de Parcelas
                </small>
                <input type="number" v-model="num_parcelas" autocomplete="off" class="form form-control" />
              </form>
            </div>
          </div>         
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="fechar_modal('dividirValoresModal')">Cancelar</button>
          <button type="button" class="btn btn-success" @click="confirmar_dividir()">Dividir</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
import * as moment from "moment";
import AzSubTitle from "../../util/AzSubTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import PagOnlineView from './PagOnlineView.vue';
import OutrasMarcacoes from '../../modulos/recepcao/OutrasMarcacoes.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PrintExport from "../../shared/PrintExport.vue";
import EspelhoAtendimento from "./EspelhoAtendimento.vue";
import LaboratorioEtiqueta from './LaboratorioEtiqueta.vue';
import PagamentoPendente from '../../shared/PagamentoPendente.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import RepasseApuracao from '../repasse/RepasseApuracao.vue';
import { subscribe, unSubscribe } from "../../../service/Notify";
import Formulario from '../consultorio/Formulario.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import DocPrintAtendimento from '../../modulos/recepcao/DocPrintAtendimento.vue';
import ZoopStatus from '../../shared/ZoopStatus.vue';
import LembretePagamento from './LembretePagamento.vue';

export default {
  data() {
    return {
      atendimento: null,
      teste: null,
      novaForma: "",
      id_atendimento: null,
      id_pagamento_atendimento: null,
      outro_responsavel: false,
      validate: false,
      pode_pagar: true,
      motivo_estorno: "",
      estornar_item: null,
      perc_desconto: 0,
      desconto_no_saldo: false, 
      mudando_desconto: false,
      adiantamentos: null,
      atends_para_pagamento: null,
      autdesc: null,
      dados: null, 
      lanc_selec: null, 
      acao_anexar: false, 
      pode_alterar_data: false, 
      ver_repasse_apuracao: false, 
      evento_subscribe: "",
      tem_endereco_antigo: false,
      id_unidade_operacao: "", 
      num_parcelas: 1, 
      item_dividir: null, 
      responsaveis: null, 
      selecionado_resp: false, 
    };
  },

  components: {
    AzSubTitle,
    AzInput,
    PagOnlineView,
    OutrasMarcacoes,
    AzSubmit,
    AzEmptyState,
    AzAuditLogButton,
    PrintExport,
    EspelhoAtendimento,
    LaboratorioEtiqueta,
    PagamentoPendente,
    AzFileUpload, 
    RepasseApuracao,
    Formulario,
    CadastroEndereco,
    DocPrintAtendimento, 
    ZoopStatus, 
    LembretePagamento, 
  },

  computed: {
    forma_pag_option_name: function () { 
        return ( ( this.is_pendente_orcamento || this.is_adiantamento ) ? 'forma_pagamentos.index.adiantado' : 'forma_pagamentos.index' ) 
                + ( this.marcacao ? this.marcacao.id_unidade_operacao : this.id_unidade_operacao );
    }, 

    valor_desconto: function () { 
      return Math.round(( this.desconto_no_saldo ? this.saldo_a_pagar() : this.atendimento.valor_total ) * this.perc_desconto) / 100;
    },

    valor_maximo_desconto: function () { 
      if ( !this.atendimento )
        return 0;

      return ( this.atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto == 'A' ) 
        ? this.valor_desconto_identificado
        : ( this.atendimento.valor_total - this.valor_desconto_identificado );
    },

    valor_desconto_identificado: function () { 
      if ( !this.atendimento || !this.atendimento.atendimento_procedimentos )
        return 0;

      if ( !this.atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto
        || this.atendimento.pagamento_atendimento.desconto.desconto.ch_escopo_desconto == 'T' ) 
        return 0;

      return this.atendimento.atendimento_procedimentos.filter(item => item.desc.fl_ativo 
          && ( item.desc.fl_procedimento || item.desc.fl_consumo ) )
        .reduce((total, atp) => total + ( 
            ( atp.desc.fl_procedimento && atp.desc.fl_consumo ) ? atp.cd_valor_total
                : ( atp.desc.fl_consumo ? atp.dc_valor_consumo
                  : atp.cd_valor_total - atp.dc_valor_consumo )
            ), 0);
    },

    nota_habilitada: function () {
      return ( this.atendimento
        && !this.atendimento.adiantamento
        && this.atendimento.marcacao
        && this.atendimento.marcacao.unidade_operacao
        && this.atendimento.marcacao.unidade_operacao.fl_nota_fiscal ) ? true : false;
    },

    is_adiantamento: function () {
      return ( this.atendimento && this.atendimento.adiantamento ) ? true : false;
    },

    is_pendente_orcamento: function () {
      return ( this.atendimento && this.atendimento.pendente && this.atendimento.id_orcamento ) ? true : false;
    },

    saldo_adiantamentos: function () { 
      if ( !this.adiantamentos )
        return 0;

      return this.adiantamentos.reduce((total, carry) => { 
        return total + parseFloat(carry.saldo_adiantamento);
      }, 0);
    },

  },

  props: ["id", "validar", "marcacao", "view"],

  watch: {
    id: {
      handler: function() {
        // this.load();
      },
      immediate: true
    }
  },

  methods: {
    incluir_lembrete () { 
        this.$refs.lembrete_pag.incluir();
    },

    refresh() { 
        this.$emit('refresh');
    },
    
    distribuir_pagamento (item) { 
        this.atendimento.pagamento_distribuido.forEach((destindo, idx) => { 
            if ( !idx ) { 
                item.id_unidade_operacao_nf = destindo.id_unidade_operacao;
                item.unid_nf = destindo.unidade_operacao;
                item.dc_valor = null; 

                this.$nextTick(() => { 
                    item.dc_valor = destindo.valor;
                });
            } else { 
                let forma = this.incluirForma(item.id_forma_pagamento, destindo.valor);
                forma.id_unidade_operacao_nf = destindo.id_unidade_operacao;
                forma.unid_nf = destindo.unidade_operacao;
            }
        });
    },

    selecionarResponsavel (resp) { 
      if ( this.atendimento.pagamento_atendimento.st_cpf_cnpj ) { 
        if ( !confirm('Confirma substituir os dados do responsável financeiro?') ) 
          return;
      }

      this.selecionado_resp = true;
      
      this.atendimento.pagamento_atendimento.st_cpf_cnpj = resp.st_cpf_cnpj;
      this.atendimento.pagamento_atendimento.st_responsavel_financeiro = resp.st_responsavel_financeiro;
      this.atendimento.pagamento_atendimento.st_email = resp.st_email;

      if ( this.atendimento.pagamento_atendimento.endereco && resp.endereco ) { 
        this.atendimento.pagamento_atendimento.endereco.in_cep = resp.endereco.in_cep;
        this.atendimento.pagamento_atendimento.endereco.st_logradouro = resp.endereco.st_logradouro;
        this.atendimento.pagamento_atendimento.endereco.st_numero = resp.endereco.st_numero;
        this.atendimento.pagamento_atendimento.endereco.st_complemento = resp.endereco.st_complemento;
        this.atendimento.pagamento_atendimento.endereco.st_bairro = resp.endereco.st_bairro;
        this.atendimento.pagamento_atendimento.endereco.id_tipo_logradouro = resp.endereco.id_tipo_logradouro;
        this.atendimento.pagamento_atendimento.endereco.cidade = resp.endereco.cidade;
        this.atendimento.pagamento_atendimento.endereco.id_estado = resp.endereco.id_estado;
      }

      this.$nextTick(() => { 
        this.selecionado_resp = false;
      });

    },

    confirmar_dividir () { 
      
      if ( this.num_parcelas > 1 && this.num_parcelas <= 36 ) { 
        let valor = this.item_dividir.dc_valor;
        let valor_parcela = Math.round( ( this.item_dividir.dc_valor / this.num_parcelas ) * 100 ) / 100; 
        let resto = valor - ( valor_parcela * this.num_parcelas );

        this.item_dividir.dc_valor = null;

        this.$nextTick(() => { 
          this.item_dividir.dc_valor = valor_parcela + resto;
        })

        for ( let i = 1; i < this.num_parcelas; i++ ) { 

            let forma = this.incluirForma(this.item_dividir.id_forma_pagamento, valor_parcela);

            if ( forma && forma.cheque && this.item_dividir.cheque ) { 

                if ( this.item_dividir.id_forma_pagamento == 4 || this.item_dividir.id_forma_pagamento == 50 ) { 

                    forma.cheque.id_banco = this.item_dividir.cheque.id_banco;
                    forma.cheque.fl_mesma_praca = this.item_dividir.cheque.fl_mesma_praca;

                    if ( this.item_dividir.cheque.in_numero ) { 
                        forma.cheque.in_numero = parseInt(this.item_dividir.cheque.in_numero) + i;
                    }

                    if ( this.item_dividir.cheque.dt_vencimento ) { 
                        let data = moment(this.item_dividir.cheque.dt_vencimento); 
                        let novaData = data.add(i, 'months');
                        forma.cheque.dt_vencimento = novaData.format('YYYY-MM-DD');
                    }
                
                } else if ( this.is_pix(this.item_dividir) ) { 

                    if ( this.item_dividir.cheque.dt_vencimento ) { 
                        let data = moment(this.item_dividir.cheque.dt_vencimento); 
                        let novaData = data.add(i, 'months');
                        forma.cheque.dt_vencimento = novaData.format('YYYY-MM-DD');
                    }

                }

            }

        }

        $('#dividirValoresModal').modal('hide');

        return;
      } 

      this.$toast.add({
        severity: "error",
        summary: "Dividir",
        detail: "Número de parcelas inválido! (2-36)",
      });

    },

    dividir (item) { 
      this.item_dividir = item;
      $('#dividirValoresModal').modal('show');
    },

    possui_nota_fiscal() {
        //console.log('dados', this.dados);
        //console.log('atendimento', this.atendimento);
        
        if(this.dados) {
            const nf =  _.get(this.dados, 'atendimento.pagamento_atendimento_link.pagamento_atendimento.nota_fiscal_link.nota_fiscal_servico');
            return nf && _.get(nf, 'ch_status') != '5'; // ultima nota fiscal com status diferente de cancelada
        }

        return false;

    },

    realizar_pagamento_app (item) { 
      if ( !item.dc_valor ) { 
        item.dc_valor = this.saldo_a_pagar();
      }

      this.$util.atualizar (this, { 
        service: 'pagamentos',
        func: 'realizar_pagamento_app',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento, 
          id_forma_pagamento: item.id_forma_pagamento, 
        }, 
        callback: () => { 
          item.aguardando_app = true;
          this.atendimento.pagamento_atendimento.aguardando_app = true;
          this.$forceUpdate();

          this.evento_subscribe = 'pagamento-app-' + this.atendimento.id_atendimento;

          subscribe (this.$store.state.dominio + '-' + this.evento_subscribe, this.evento_subscribe, retorno => {
            console.log('pusher app', retorno);

            if ( retorno && retorno.data && retorno.data.status == 'OK' ) { 
              this.load();

              this.$toast.add({
                severity: "success",
                summary: "Pagamento",
                detail: "Pagamento realizado com sucesso!",
              });

              const el = document.getElementById("beepPagId");

              if ( el ) { 
                el.play();
              }
            }
          });
        },
        final: () => { 
          this.validate = false;
          item.dc_valor = 0;
        }

      });
    },

    calcular_desconto_lista() { 
      if ( this.$store.state.loading )
        return;

      this.atendimento.pagamento_atendimento.desconto.desconto.autorizador = null;

      /*
      if ( this.atendimento.pagamento_atendimento.desconto.desconto.desconto_tipo ) { 
        this.perc_desconto = this.atendimento.pagamento_atendimento.desconto.desconto.desconto_tipo.dc_desconto;
      } else { 
        this.perc_desconto = 0 ;
      }

      this.calcular_desconto();
      */
    },

    abrir_anexar_arquivo(item) { 
      this.lanc_selec = item;

      if ( this.lanc_selec.arquivos && this.lanc_selec.arquivos.length && !this.lanc_selec.arquivos.find(arq => arq.arquivo) ) { 

        this.lanc_selec.carregando = true; 

        this.carregar_arquivos(true);

      } else { 

        this.acao_anexar = true;

        this.$nextTick(() => { 
          this.$refs.upload.abrir();
        });
        
      }

    },

    carregar_arquivos (abrir = false) { 

      this.$store.commit('loading', true);

      this.$util.loadItem(this, { 
        service: 'arquivos',
        func: 'links',
        parms: { 
          id: this.lanc_selec.id_lancamento,
          type: 'lancamento', 
        },
      })
      .then(res => { 
        this.lanc_selec.arquivos = res;
        this.acao_anexar = true;

        if ( abrir ) { 
          this.$nextTick(() => { 
            this.$refs.upload.abrir();
          });
        }
      })
      .finally(() => { 
        this.lanc_selec.carregando = false; 
        this.$store.commit('loading', false);
      });

    },

    lista_lancamentos (atendimento) { 
      if ( !atendimento.pagamento_atendimento || !atendimento.pagamento_atendimento.item_pagamento_atendimentos )
        return [];

      return atendimento.pagamento_atendimento.item_pagamento_atendimentos.flatMap(itp => { 
        return itp.lancamentos ? itp.lancamentos : [];
      });
    },

    reabrir(item) {
      this.$emit("reabrir", item);
    },

    set_valor(item) {
      let saldo = this.saldo_a_pagar();

      if ( item.id_forma_pagamento == 99 && item.adiantamento ) {
        saldo = item.dc_valor > 0 ? 0 : item.adiantamento.saldo_adiantamento;
      }

      item.dc_valor = null;

      this.$nextTick(() => {
        item.dc_valor = saldo;
      });
    },

    is_pix(item) {
      return ( item && item.forma_pagamento && item.forma_pagamento.search.toUpperCase().indexOf('PIX') >= 0 ) ? true : false;
    },

    calcular_desconto() {
      $('#pagamentoDescontoModal').modal('hide');

      this.mudando_desconto = true;
      this.atendimento.pagamento_atendimento.desconto.desconto.dc_valor = this.valor_desconto;

      this.$nextTick(() => {
        this.mudando_desconto = false;
      });
    },

    abrir_calc_desconto() {
      this.perc_desconto = 0;
      $('#pagamentoDescontoModal').modal('show');
    },

    fechar_modal(modal) {
      $('#' + modal).modal('hide');
    },

    adiantamento(valor = 0, outros_params = {}) {
      this.id_pagamento_atendimento = null;
      this.id_atendimento = null;
      
      let uo = this.$util.unidade_operacao();

      this.atendimento = {
        ...outros_params,
        id_atendimento: null,
        fl_reembolso: false, 
        adiantamento: outros_params.pendente ? false : true,
        valor_total: valor,
        marcacao: {
        },
        pagamento_atendimento: {
          item_pagamento_atendimentos: [],
          id_unidade_operacao: uo ? uo.id_unidade_operacao : null, 
          dt_data: outros_params.data_pag ? outros_params.data_pag : null,
          id_plano: outros_params.id_plano_particular ? outros_params.id_plano_particular : null, 
          dc_valor_adiantado: outros_params.pendente ? outros_params.dc_valor_adiantado : valor, 
          desconto: {
            desconto: {
              dc_valor: 0,
            }
          }, 
          medico: outros_params.medico ? outros_params.medico : null, 
        },
      };

      this.$util.loadItem(this, { 
        service: 'configuracoes',
        func: 'index',
        parms: {
          where: {
            st_slug: 'pagamento-alterar-data',
            fl_ativo: '1',
          }
        }
      })
      .then(res => { 
        this.pode_alterar_data = ( _.get(res, '0.st_valor') > 0 );
      });
    },

    pesquisarCpf(cpf) {
      if ( this.selecionado_resp ) { 
        return;
      }

      if ( cpf && cpf.length == 11 ) {
        if(this.atendimento.pagamento_atendimento.endereco.id_endereco) {
          return;
        }
        this.$util.loadItem(this, {
          service:'pacientes',
          func: 'index',
          parms: {
            search: cpf,
          }
        })
        .then(res => {
          console.log('endereço', res);
          if ( res && res.length >= 1 ) {
            this.atendimento.pagamento_atendimento.st_responsavel_financeiro = res[0].st_nome;
            this.atendimento.pagamento_atendimento.st_email = res[0].cadastro ? res[0].cadastro.st_email : '';

            if ( res[0].cadastro && res[0].cadastro.endereco ) {

              const endereco = res[0].cadastro.endereco.st_logradouro +
                ( res[0].cadastro.endereco.st_complemento ? ', ' + res[0].cadastro.endereco.st_complemento : '' ) +
                ( res[0].cadastro.endereco.st_numero ? ', No.' + res[0].cadastro.endereco.st_numero : '' ) +
                ( res[0].cadastro.endereco.st_numero ? ', No.' + res[0].cadastro.endereco.st_numero : '' ) +
                ( res[0].cadastro.endereco.st_bairro ? ', ' + res[0].cadastro.endereco.st_bairro : '' ) +
                ( res[0].cadastro.endereco.in_cep ? ', CEP ' + res[0].cadastro.endereco.in_cep : '' ) +
                ( res[0].cadastro.endereco.cidade ? ', ' + res[0].cadastro.endereco.cidade.st_cidade : '' );

              this.atendimento.pagamento_atendimento.st_endereco = endereco;
              if(this.atendimento.pagamento_atendimento.endereco && !this.tem_endereco_antigo) {
                this.atendimento.pagamento_atendimento.endereco = res[0].cadastro.endereco;
              }

            }
          }
        });
      }

      if(!cpf || (cpf && cpf.length == 0)) {
        this.atendimento.pagamento_atendimento.st_responsavel_financeiro = '';
        this.atendimento.pagamento_atendimento.st_email = '';
        this.atendimento.pagamento_atendimento.st_endereco = '';
        this.atendimento.pagamento_atendimento.endereco = {};
      }

    },
    parcelas(id_bandeira_cartao, name = null) {
      let lista = [];
      let bandeiras = this.$store.state.options[name ? name : "bandeira_cartaos.index"];

      if (!bandeiras) return lista;

      let bandeira = bandeiras.find(item => {
        return item.id_bandeira_cartao == id_bandeira_cartao;
      });

      if (bandeira) {
        for (
          let index = 1;
          index <= bandeira.bandeira_cartao_unidade.in_maximo_parcelas;
          index++
        ) {
          lista.push({ id: index, search: index + "x" });
        }
      } else {
        lista.push({ id: 1, search: "1x" });
      }

      let options = {
        name: "parcelas." + id_bandeira_cartao,
        list: lista
      };

      this.$store.commit("setOptions", options);

      return lista;
    },

    abrir_pagamento(id_pagamento_atendimento) { // , callback = null
      this.id_atendimento = null;
      this.id_pagamento_atendimento = id_pagamento_atendimento;

      this.$store.commit("loading", true);

      this.$util.loadItem(this, {
        service: 'pagamentos',
        func: 'show',
        parms: {
          id: id_pagamento_atendimento,
          carregar_endereco: true,
        }
      })
      .then(res => {
        if ( res.dc_valor_adiantado !== null ) {
          this.id_pagamento_atendimento = res.id_pagamento_atendimento;
          this.id_atendimento = null;

          this.atendimento = {
            id_atendimento: null,
            adiantamento: true,
            fl_reembolso: false, 
            valor_total: res.dc_valor_adiantado,
            marcacao: {},
            pagamento_atendimento: res,
          };

          this.$store.commit("loading", false);

        } else if ( res.pagamento_atendimento_links && res.pagamento_atendimento_links.length ) {

          this.abrir_mult(
            res.pagamento_atendimento_links[0].model.id_atendimento,
            res.pagamento_atendimento_links.map(item => item.model)
          );

        } else if ( res.id_atendimento ) {

          this.abrir(res.id_atendimento);

        } else {

          this.$store.commit("loading", false);

        }
        
        this.loadEndereco();
      })
      .catch(() => {
        this.$store.commit("loading", false);
      });

    },

    abrir(id_atendimento, callback = null) {
      this.id_atendimento = id_atendimento;
      // this.id_pagamento_atendimento = null;
      this.load(callback);
    },

    abrir_mult(id_atendimento, lista, callback = null) {
      this.id_atendimento = id_atendimento;
      // this.id_pagamento_atendimento = null;
      this.atends_para_pagamento = lista;
      this.load(callback);
    },

    excluirItem(item, index) {
      $('[data-toggle="tooltip"]').tooltip("hide");

      if (item.id_item_pagamento_atendimento) {
        if (item.estorno && item.estorno.ch_situacao == "S")
          this.autorizar_estorno(item);
        else this.solicitar_estorno(item);
      } else {
        this.atendimento.pagamento_atendimento.item_pagamento_atendimentos.splice(
          index,
          1
        );
      }
    },

    cor_saldo() {
      return this.saldo_a_pagar() == 0
        ? "alert-success"
        : this.saldo_a_pagar() < 0
        ? "alert-primary"
        : "alert-danger";
    },

    saldo_a_pagar() {
      let saldo = this.atendimento.valor_total;

      if (this.atendimento.pagamento_atendimento.desconto) {
        if (this.atendimento.pagamento_atendimento.desconto.desconto.dc_valor)
          saldo =
            saldo -
            parseFloat(
              this.atendimento.pagamento_atendimento.desconto.desconto.dc_valor
            );
      }

      this.atendimento.pagamento_atendimento.item_pagamento_atendimentos.forEach(
        element => {
          if (
            element.dc_valor &&
            (!element.estorno || element.estorno.ch_situacao != "A")
          )
            saldo = saldo - parseFloat(element.dc_valor);
        }
      );

      return Math.round(saldo * 100) / 100;
    },

    incluirForma(forma_parm = null, valor = 0) {
      let id_forma_pagamento;

      if ( forma_parm && valor ) { 
        id_forma_pagamento = forma_parm;
      } else { 
        if (!this.novaForma) 
          return;

        id_forma_pagamento = this.novaForma;
      }

      let origem = this.forma_pag_option_name;

      const lista = this.$store.state.options[origem];
      let formaPag;

      if ( lista ) {
        formaPag = lista.find(item => item.id_forma_pagamento == id_forma_pagamento);

        console.log('forma', formaPag);
      } else { 

        console.log('forma2', formaPag, this.forma_pag_option_name);
      }

      let forma = {
        id_forma_pagamento: id_forma_pagamento,
        dc_valor: valor,
        forma_pagamento: formaPag,
        adiantamento: "",
        cheque: {
          id_banco: "",
          in_numero: "",
          dt_vencimento: "",
          fl_mesma_praca: true
        }
      };

      this.atendimento.pagamento_atendimento.item_pagamento_atendimentos.push(
        forma
      );

      this.novaForma = "";

      this.$nextTick(() => {
        if ( this.novaForma == 90 ) { 
          this.novaForma = null;
        } else { 
          this.novaForma = null;
          let idx = this.atendimento.pagamento_atendimento.item_pagamento_atendimentos.length - 1;
          this.$refs['valorparticular' + idx][0].$refs.input.$el.focus();
        }
      });

      return forma;
    },

    format(n) {
      let formatter = new Intl.NumberFormat("pt-Br", {
        style: "currency",
        currency: "BRL",
        currencyDisplay: "code"
      });

      return formatter.format(n).substr(4);
    },

    load(callback = null) {
      if ( this.evento_subscribe ) { 
        unSubscribe(this.$store.state.dominio + '-' + this.evento_subscribe, this.evento_subscribe);
      }

      this.id_unidade_operacao = "";
      this.dados = null; 
      this.autdesc = null;
      this.atendimento = null;
      this.adiantamentos = null;
      this.outro_responsavel = false;
      this.ver_repasse_apuracao = false;
      this.responsaveis = null; 
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "atendimentos.show",
            id: "atendimento",
            parms: {
              id: this.id_atendimento,
              pagamento: true
            },
            with: ["paciente.cadastro.endereco.estado"]
          },
          {
            name: "pagamentos.pode_realizar_pagamento",
            id: "pode",
          },
          {
            name: "pagamentos.adiantamentos",
            id: "adiantamentos",
            parms: {
              id_atendimento: this.id_atendimento,
            },
          },
          {
            name: "pagamentos.responsaveis",
            id: "responsaveis",
            parms: {
              id_atendimento: this.id_atendimento,
            },
          },
          {
            name: 'configuracoes.index',
            id: 'configdata',
            parms: {
              where: {
                st_slug: 'pagamento-alterar-data',
                fl_ativo: '1',
              }
            } 
          },
          {
            name: 'configuracoes.index',
            id: 'configrepasse',
            parms: {
              where: {
                st_slug: 'pagamento-ver-apuracao',
                fl_ativo: '1',
              }
            } 
          },
          {
            name: "marcacoes.show",
            id: "marcacao",
            parms: {
              id: this.marcacao ? this.marcacao.id_marcacao : -1,
              pagamento: true,
              buscar_outras: true, 
              guia_tiss: false,
            },
            with: [
                "paciente.cadastro.endereco.cidade.estado",
                "atendimento.atendimento_procedimentos.terceiro.terceiro",
                "atendimento.pagamentoAtendimento.itemPagamentoAtendimentos.notaFiscalLinks.notaFiscalServico",
                "atendimento.pagamentoAtendimento.itemPagamentoAtendimentos.bandeiraCartao:id_bandeira_cartao,st_bandeira_cartao",
                "atendimento.medico.conselho",
                "atendimento.medico.estado_conselho",
                "unidade_operacao:id_unidade_operacao,st_nome,id_endereco,st_cnpj,fl_nota_fiscal,fl_nota_fiscal_eletronica",
                "unidade_operacao.endereco.cidade.estado",
                "unidade_operacao.telefoneUnidadeOperacaos.telefone",
                // "atendimento.pagamentoAtendimento.endereco.cidade.estado"
            ]
          },
        ]
      };

      if ( this.atends_para_pagamento && this.atends_para_pagamento.length > 1 ) {
        this.atends_para_pagamento.filter(item => item.id_atendimento != this.id_atendimento)
          .forEach(item => {
            query.q.push({
                name: "atendimentos.show",
                id: "atendimento." + item.id_atendimento,
                parms: {
                  id: item.id_atendimento,
                  pagamento: true
                },
            });
          });
      }

      this.axios
        .post("/aql?a=atendimentos.show", query)
        .then(res => {
          console.log('>>>>>> load', res);
          if (res.data.pode.status == 200) {
            this.pode_pagar = res.data.pode.data;
          }

          if (res.data.marcacao.status == 200) {
            this.dados = res.data.marcacao.data;
          }

          if ( res.data.responsaveis && res.data.responsaveis.status == 200 ) { 
            this.responsaveis = res.data.responsaveis.data;
          }

          if ( res.data.configdata && res.data.configdata.status == 200 ) { 
            this.pode_alterar_data = ( _.get(res.data.configdata.data, '0.st_valor') > 0 );
          }

          if ( res.data.configrepasse && res.data.configrepasse.status == 200 ) { 
            this.ver_repasse_apuracao = ( _.get(res.data.configrepasse.data, '0.st_valor') > 0 );
          }

          if (res.data.atendimento.status == 200) {
            if ( !this.dados ) { 
              this.id_unidade_operacao = _.get(res.data.atendimento.data, 'marcacao.id_unidade_operacao');
            }

            console.log(">>>>> atendimento", res.data.atendimento.data);

            let outros_valores = 0;

            if ( this.atends_para_pagamento && this.atends_para_pagamento.length > 1 ) {
              outros_valores = this.atends_para_pagamento.reduce((total, carry) => {
                if ( carry.id_atendimento == this.id_atendimento )
                  return total;

                if ( res.data['atendimento.' + carry.id_atendimento].status == 200 ) {
                  return total + parseFloat(res.data['atendimento.' + carry.id_atendimento].data.valor_total);
                }
              }, 0);
            }

            this.atendimento = res.data.atendimento.data;
            this.atendimento.valor_total += outros_valores;

            if ( this.atendimento.pagamento ) {
              this.atendimento.pagamento_atendimento = this.atendimento.pagamento;
            }

            if ( this.atends_para_pagamento && this.atends_para_pagamento.length > 1 ) {
              this.atendimento.lista = this.atends_para_pagamento
            }

            console.log('1111', this.atendimento);

            if (!this.atendimento.pagamento_atendimento) {
              let desconto_tipo = ( _.get(this.atendimento, 'marcacao.orcamento.desconto_tipo') 
                  && ( _.get(this.atendimento, 'marcacao.orcamento.id_usuario_desconto') ) ) 
                ? _.get(this.atendimento, 'marcacao.orcamento.desconto_tipo')
                : null; 

              let valor_desconto = 0; 
              
              if ( desconto_tipo && _.get(this.atendimento, 'marcacao.orcamento.dc_desconto') && _.get(this.atendimento, 'marcacao.orcamento.ch_tipo_desconto') == 'P' ) { 
                valor_desconto = Math.round(this.atendimento.valor_total * this.atendimento.marcacao.orcamento.dc_desconto) / 100;
              } else if ( desconto_tipo && _.get(this.atendimento, 'marcacao.orcamento.dc_desconto') && _.get(this.atendimento, 'marcacao.orcamento.ch_tipo_desconto') == 'V' ) { 
                valor_desconto = this.atendimento.marcacao.orcamento.dc_desconto;
              }

              this.atendimento.pagamento_atendimento = {
                desconto: { 
                  desconto: { 
                    ch_escopo_desconto: 'T', 
                    dc_valor: valor_desconto, 
                    desconto_tipo: desconto_tipo,
                    st_desconto: desconto_tipo ? 'Orçamento #' + this.atendimento.marcacao.orcamento.id_orcamento : null,
                  } 
                },
                item_pagamento_atendimentos: [],
                st_cpf_cnpj: "",
                st_email: "",
                dt_data: this.pode_alterar_data ? this.$util.hoje() : null, 
                campos_customizados: this.atendimento.pag_campos_customizados,
              };

              if ( this.atendimento.marcacao.pagamento_online && this.atendimento.marcacao.pagamento_online.ch_status == 'P' ) {
                this.atendimento.pagamento_atendimento.item_pagamento_atendimentos.push({
                  id_forma_pagamento: 2,
                  dc_valor: this.atendimento.marcacao.pagamento_online.dc_valor,
                  st_autorizacao: this.atendimento.marcacao.pagamento_online.nsu,
                  in_parcelas: 1,
                });
              }
            } else {
              if (!this.atendimento.pagamento_atendimento.desconto) {
                this.atendimento.pagamento_atendimento.desconto = {
                  desconto: {
                    ch_escopo_desconto: 'T',
                    dc_valor: 0, 
                  }
                };
              }

              if (
                this.atendimento.pagamento_atendimento.st_responsavel_financeiro
              ) {
                this.outro_responsavel = true;
              }
            }
          }

          if(!_.get(this.atendimento, 'pagamento_atendimento.endereco')) {
            this.atendimento.pagamento_atendimento.endereco = {};
          }

          if (res.data.adiantamentos.status == 200) {
            this.adiantamentos = res.data.adiantamentos.data;
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);

          const enderecoAntigo = _.get(this.atendimento, 'pagamento_atendimento.st_endereco');
          const enderecoNovo = _.get(this.atendimento, 'pagamento_atendimento.id_endereco');
          this.tem_endereco_antigo = enderecoAntigo && !enderecoNovo ? true : false;

          if ( callback )
            callback();
        });
    },

    loadEndereco() {
        const enderecoAntigo = _.get(this.atendimento, 'pagamento_atendimento.st_endereco');
        const enderecoNovo = _.get(this.atendimento, 'pagamento_atendimento.id_endereco');
        this.tem_endereco_antigo = enderecoAntigo && !enderecoNovo ? true : false;

        if ( _.get(this.atendimento, 'pagamento_atendimento.st_responsavel_financeiro') ) {
          this.outro_responsavel = true;
        }
    },

    atualizar(callback, final) {
      $('#autDescontoModal').modal('hide');

      if ( this.atendimento.pagamento_atendimento.desconto
        && ( this.atendimento.pagamento_atendimento.desconto.desconto.dc_valor > 0 ) 
        && ( Math.round(this.atendimento.pagamento_atendimento.desconto.desconto.dc_valor * 100) > Math.round(this.valor_maximo_desconto * 100) ) 
      ) { 

        this.$toast.add({
          severity: "error",
          summary: "Desconto",
          detail: "Desconto informado superior ao valor disponível: " 
            + this.$util.formatMoeda(this.atendimento.pagamento_atendimento.desconto.desconto.dc_valor)
            + ' > ' 
            + this.$util.formatMoeda(this.valor_maximo_desconto),
          life: 5000
        });

        final();

        return;

      }

      this.$util.atualizar (this, {
        service: "pagamentos",
        func: "store",
        dados: {
          atendimento: this.atendimento,
          autdesc: this.autdesc,
        },
        callback: res => callback(res),
        error: err => {
          this.autdesc = null;

          if ( err && err.info == 'desconto' ) {
            this.autdesc = {
              login: "",
              senha:"",
              callback: callback,
              final: final,
            };

            this.validate = false;

            this.$nextTick(() => {
              $('#autDescontoModal').modal('show');
            });
          }
        },
        final: () => {
          final();
        },
        conflict_reload: () => this.load(),
      });
    },

    item_status(item) {
      if (item.estorno && item.estorno.ch_situacao == "S") {
        return {
          icon: "fas fa-exclamation-circle fa-fw",
          color: "outline-warning",
          tooltip: "Solicitado" + ( item.estorno.st_motivo ? ': ' + item.estorno.st_motivo : '' ),
          text: "fas fa-exclamation-circle fa-fw",
          action: this.autorizar_estorno
        };
      } else if (item.estorno && item.estorno.ch_situacao == "A") {
        return {
          icon: "fas fa-ban fa-fw",
          color: "outline-secondary",
          tooltip: "Estornado",
          text: "",
          action: null
        };
      } else if (item.id_item_pagamento_atendimento) {
        return {
          icon: "fas fa-undo-alt fa-fw",
          color: "outline-danger",
          tooltip: "Solicitar Estorno",
          text: "fas fa-undo-alt fa-fw",
          action: this.solicitar_estorno
        };
      } else {
        return {
          icon: "fas fa-minus fa-fw",
          color: "outline-danger",
          tooltip: "Remover",
          text: "fas fa-minus fa-fw",
          action: this.excluirItem
        };
      }
    },

    solicitar_estorno(item) {
      if ( this.view )
        return;

      this.motivo_estorno = "";
      this.estornar_item = item;
      $('#estornoMotivoModal').modal('show');
    },

    enviar_solicitar_estorno() {

      this.$util.atualizar(this, {
        service: 'pagamentos',
        func: 'solicitar_estorno',
        modal: 'estornoMotivoModal',
        toast: true,
        dados: {
          id: this.estornar_item.id_item_pagamento_atendimento,
          recepcao: true,
          motivo: this.motivo_estorno,
        },
        callback: () => {
          if ( this.is_adiantamento ) {
            if ( this.id_pagamento_atendimento ) {
              this.abrir_pagamento(this.id_pagamento_atendimento);
            }
          } else {
            this.load();
          }

          this.$emit("refresh");
        }
      });

      /*
      let query = {
        q: [
          {
            name: "pagamentos.solicitar_estorno",
            id: "estorno",
            parms: {
              id: this.estornar_item.id_item_pagamento_atendimento,
              recepcao: true,
            }
          }
        ]
      };

      return this.axios.post("/aql", query).then(res => {
        if (res.data.estorno.status == 200) {
          this.load();
        }
      });
      */
    },

    autorizar_estorno(item) {
      if ( this.view )
        return;

      this.$util.atualizar (this, {
        service: 'pagamentos',
        func: 'autorizar_estorno',
        modal: 'nenhum',
        dados: {
          id: item.id_item_pagamento_atendimento,
          recepcao: true,
        },
        callback: () => {
          this.load();
          this.$emit("refresh");
        }
      });

      /*
      let query = {
        q: [
          {
            name: "pagamentos.autorizar_estorno",
            id: "estorno",
            parms: {
              id: item.id_item_pagamento_atendimento
            }
          }
        ]
      };

      return this.axios.post("/aql", query).then(res => {
        if (res.data.estorno.status == 200) {
          this.load();
          this.$emit("refresh");
        }
      });
      */
    },

    imprimirRecibo() {
      this.$htmlToPaper("impressao-recibo");
    },

    notaFiscalHabilitada() {
        return this.atendimento
          && !this.atendimento.adiantamento
          && this.atendimento.marcacao
          && this.atendimento.marcacao.unidade_operacao
          && this.atendimento.marcacao.unidade_operacao.fl_nota_fiscal;
    },

    ajustar_selecao() {
      this.atendimento.pagamento_atendimento.st_responsavel_financeiro = "";
      this.atendimento.pagamento_atendimento.st_cpf_cnpj = "";
      this.atendimento.pagamento_atendimento.st_endereco = "";
      this.atendimento.pagamento_atendimento.st_email = "";
      this.atendimento.pagamento_atendimento.id_endereco = null
      this.atendimento.pagamento_atendimento.endereco = {};
    }
  }
};
</script>